'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `simpleMenusLib.emptyState.${key}`;
const MenuEmptyState = ({
  addNode,
  readOnly
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "menus-empty-state",
    className: "simple-menus-menu-empty-state",
    children: [/*#__PURE__*/_jsx("div", {
      className: "illustration",
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "empty-state-charts"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "content",
      children: [/*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('header')
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('body')
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "add-menu-item-simple",
        disabled: readOnly,
        onClick: addNode,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('button')
        })
      })]
    })]
  });
};
MenuEmptyState.propTypes = {
  addNode: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
export default MenuEmptyState;